<template>
  <section>
    <div class="flex justify-between">
      <div :id="`${uid}-name`" class="font-sans text-base">
        {{ name }}
      </div>
      <div class="font-sans text-base">
        <span v-if="label" :id="`${uid}-quantity-at-price`" class="text-fg-secondary">
          {{ label }}
        </span>
        <span :id="`${uid}`">
          {{ currency(amount) }}
        </span>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import { mapState, mapStores } from 'pinia'
import { defineComponent } from 'vue'

import { useSettingStore } from '@/stores/setting'

export default defineComponent({
  name: 'TransactionLine',
  props: {
    name: {
      type: String,
      required: false,
    },
    amount: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    uid: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapStores(useSettingStore),
    ...mapState(useSettingStore, ['currency']),
  },
})
</script>
